import React from 'react';
import constantObject from 'utilities/constantObject';
import {normalize} from 'utilities/URL';
import {toReactStyle} from 'utilities/DOM';
import isEmpty from 'lodash/isEmpty';

const TAGS = constantObject([
  'a',
  'abbr',
  'acronym',
  'address',
  'article',
  'aside',
  'b',
  'bdi',
  'bdo',
  'big',
  'blockquote',
  'br',
  'caption',
  'center',
  'cite',
  'code',
  'col',
  'dd',
  'del',
  'dfn',
  'dir',
  'div',
  'dl',
  'dt',
  'dynamic-text',
  'em',
  'figcaption',
  'figure',
  'font',
  'footer',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'i',
  'img',
  'ins',
  'kbd',
  'label',
  'li',
  'map',
  'mark',
  'menu',
  'nav',
  'ol',
  'p',
  'pre',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'section',
  'small',
  'span',
  'strike',
  'strong',
  'sub',
  'summary-number',
  'sup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'time',
  'tr',
  'tt',
  'u',
  'ul',
  'var',
]);

const ATTRIBUTES = {
  class: 'className',
  ...constantObject([
    'abbr',
    'align',
    'alt',
    'axis',
    'bgcolor',
    'border',
    'cellpadding',
    'cellspacing',
    'clear',
    'color',
    'cols',
    'colspan',
    'compact',
    'coords',
    'data-drill', // phoenix tables
    'dir',
    'face',
    'headers',
    'height',
    'href',
    'hreflang',
    'hspace',
    'ismap',
    'lang',
    'language',
    'nohref',
    'nowrap',
    'referrerpolicy',
    'rel',
    'rev',
    'rows',
    'rowspan',
    'rules',
    'scope',
    'scrolling',
    'shape',
    'size',
    'span',
    'src',
    'start',
    'summary',
    'tabindex',
    'target',
    'title',
    'type',
    'valign',
    'value',
    'vspace',
    'width',
  ]),
};
const URI_ATTRIBUTES = constantObject(['href']);

const LI = 'li';
const UL = 'ul';
const NONE = 'none';

const transformValue = attribute =>
  URI_ATTRIBUTES[attribute.name] ? normalize(attribute.value) : attribute.value;

const transformAttributes = attributes => {
  return Array.from(attributes).reduce((memo, attr) => {
    const attrKey = ATTRIBUTES[attr.name];

    if (attrKey) memo[attrKey] = transformValue(attr);

    return memo;
  }, {});
};

const isLiWithChildUl = node => {
  return (
    node.tagName.toLowerCase() === LI &&
    node.childNodes.length > 0 &&
    node.childNodes[0].tagName &&
    node.childNodes[0].tagName.toLowerCase() == UL
  );
};

const mapChildNode = (node, index) => transform(node, {key: index}); //eslint-disable-line no-use-before-define

const transform = (node, props) => {
  if (!node) return null;

  switch (node.nodeType) {
    case 1: {
      const component = TAGS[node.tagName.toLowerCase()];
      if (!component) return null;

      const children =
        node.childNodes.length > 0
          ? [...node.childNodes].map(mapChildNode)
          : null;

      const reactStyle = {
        ...toReactStyle(node.style),
      };
      if (isLiWithChildUl(node)) {
        reactStyle.listStyle = NONE;
      }

      const styleProps = isEmpty(reactStyle) ? null : {style: reactStyle};

      return React.createElement(component, {
        ...props,
        ...transformAttributes(node.attributes),
        ...styleProps,
        children,
      });
    }
    case 3:
      return node.textContent;
    default:
      return null;
  }
};

export default transform;
